// extracted by mini-css-extract-plugin
module.exports = {"input":"style_input__TCCRC","label":"style_label__3jewL"};